/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { axios } from 'api'
import { Product } from 'hooks/useProduct'

const useProduct = () => {
  const [hardware, setHardware] = useState<Product[]>([])
  const [richelieu, setRichelieu] = useState<Product[]>([])

  const collectProducts = (node: any): Product[] => {
    let products: Product[] = []

    if (Array.isArray(node)) {
      products = products.concat(node)
    } else if (typeof node === 'object' && node !== null) {
      for (const key in node) {
        products = products.concat(collectProducts(node[key]))
      }
    }

    return products
  }

  const fetchHardware = async () => {
    const response = await axios.get('/products?itemClass=Hardware')

    const productsData = response.data.products
    const products = collectProducts(productsData)
    setHardware(products)
  }

  const fetchRichelieu = async () => {
    const response = await axios.get('/products?itemClass=Richelieu')

    const productsData = response.data.products
    const products = collectProducts(productsData)
    setRichelieu(products)
  }

  // Load both product groups once when the hook mounts.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchHardware()
    fetchRichelieu()
  }, [])

  return {
    fetchHardware,
    fetchRichelieu,
    hardware,
    richelieu
  }
}

export default useProduct
